/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Helpful_Kind_Bird_RequestInputs */

const en_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not complete your request.`)
};

const id_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat menyelesaikan permintaan Anda.`)
};

const ms_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat melengkapkan permintaan anda.`)
};

const ca_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hem pogut completar la teva sol·licitud.`)
};

const cs_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaši žádost nelze dokončit.`)
};

const da_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke fuldføre din anmodning.`)
};

const de_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Anfrage konnte nicht abgeschlossen werden.`)
};

const et_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teie taotlust ei saanud täita.`)
};

const es_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo completar tu solicitud.`)
};

const fr_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre demande n’a pas pu aboutir.`)
};

const hr_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nismo mogli dovršiti vaš zahtjev.`)
};

const it_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile completare la tua richiesta.`)
};

const lv_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nevarēja izpildīt jūsu pieprasījumu.`)
};

const lt_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negalėjome užbaigti jūsų užklausos.`)
};

const hu_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A kérését nem sikerült teljesíteni.`)
};

const nl_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je verzoek kon niet worden voltooid.`)
};

const nb_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke fullføre forespørselen din.`)
};

const pl_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się zrealizować żądania.`)
};

const pt_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível completar sua solicitação.`)
};

const ro_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-a putut finaliza cererea dvs.`)
};

const sk_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vašu požiadavku nebolo možné vykonať.`)
};

const sl_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše zahteve ni bilo mogoče izpolniti.`)
};

const fi_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emme voineet suorittaa pyyntöäsi.`)
};

const sv_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte slutföra din begäran.`)
};

const vi_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể hoàn thành yêu cầu của bạn.`)
};

const tr_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İsteğinizi tamamlayamadık.`)
};

const el_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν ήταν δυνατή η ολοκλήρωση του αιτήματός σας.`)
};

const bg_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не можахме да завършим вашата заявка.`)
};

const ru_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось выполнить ваш запрос.`)
};

const sr_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Није могуће завршити ваш захтев.`)
};

const uk_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося виконати ваш запит.`)
};

const ka_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`სისტემამ ვერ შეძლო თქვენი მოთხოვნის შესრულება.`)
};

const hi_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका अनुरोध पूरा नहीं हो सका।`)
};

const th_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถทำตามคำขอของคุณได้`)
};

const ko_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요청을 완료할 수 없습니다.`)
};

const zh_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法完成您的请求。`)
};

const zh_tw_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法完成您的要求。`)
};

const ja_helpful_kind_bird_request = /** @type {(inputs: Helpful_Kind_Bird_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リクエストを完了できませんでした。`)
};

/**
* | output |
* | --- |
* | "Could not complete your request." |
*
* @param {Helpful_Kind_Bird_RequestInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const helpful_kind_bird_request = /** @type {((inputs?: Helpful_Kind_Bird_RequestInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Helpful_Kind_Bird_RequestInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_helpful_kind_bird_request(inputs)
	if (locale === "ms") return ms_helpful_kind_bird_request(inputs)
	if (locale === "ca") return ca_helpful_kind_bird_request(inputs)
	if (locale === "cs") return cs_helpful_kind_bird_request(inputs)
	if (locale === "da") return da_helpful_kind_bird_request(inputs)
	if (locale === "de") return de_helpful_kind_bird_request(inputs)
	if (locale === "et") return et_helpful_kind_bird_request(inputs)
	if (locale === "es") return es_helpful_kind_bird_request(inputs)
	if (locale === "fr") return fr_helpful_kind_bird_request(inputs)
	if (locale === "hr") return hr_helpful_kind_bird_request(inputs)
	if (locale === "it") return it_helpful_kind_bird_request(inputs)
	if (locale === "lv") return lv_helpful_kind_bird_request(inputs)
	if (locale === "lt") return lt_helpful_kind_bird_request(inputs)
	if (locale === "hu") return hu_helpful_kind_bird_request(inputs)
	if (locale === "nl") return nl_helpful_kind_bird_request(inputs)
	if (locale === "nb") return nb_helpful_kind_bird_request(inputs)
	if (locale === "pl") return pl_helpful_kind_bird_request(inputs)
	if (locale === "pt") return pt_helpful_kind_bird_request(inputs)
	if (locale === "ro") return ro_helpful_kind_bird_request(inputs)
	if (locale === "sk") return sk_helpful_kind_bird_request(inputs)
	if (locale === "sl") return sl_helpful_kind_bird_request(inputs)
	if (locale === "fi") return fi_helpful_kind_bird_request(inputs)
	if (locale === "sv") return sv_helpful_kind_bird_request(inputs)
	if (locale === "vi") return vi_helpful_kind_bird_request(inputs)
	if (locale === "tr") return tr_helpful_kind_bird_request(inputs)
	if (locale === "el") return el_helpful_kind_bird_request(inputs)
	if (locale === "bg") return bg_helpful_kind_bird_request(inputs)
	if (locale === "ru") return ru_helpful_kind_bird_request(inputs)
	if (locale === "sr") return sr_helpful_kind_bird_request(inputs)
	if (locale === "uk") return uk_helpful_kind_bird_request(inputs)
	if (locale === "ka") return ka_helpful_kind_bird_request(inputs)
	if (locale === "hi") return hi_helpful_kind_bird_request(inputs)
	if (locale === "th") return th_helpful_kind_bird_request(inputs)
	if (locale === "ko") return ko_helpful_kind_bird_request(inputs)
	if (locale === "zh") return zh_helpful_kind_bird_request(inputs)
	if (locale === "zh-tw") return zh_tw_helpful_kind_bird_request(inputs)
	if (locale === "ja") return ja_helpful_kind_bird_request(inputs)
	return en_helpful_kind_bird_request(inputs)
});